import { useState } from 'react';
import { Pagination } from '@mui/material';
import * as TopList from 'components/Layout/Tiles/ListContainer';
import { TileContent } from 'components/Layout/PageContainer';
import { useModelService } from 'services/model/model.service';
import { findIconForCategory } from 'pages/insights-pro/common/icons/CategoryIcons';
import { EmptyState } from 'components/EmptyState';
import { CategoryInfo } from '../model';
import { useCategoryNavigate } from 'pages/insights-pro/category-tab/useCategoryNavigate';

interface TopBottomCategoriesProps {
  categories: CategoryInfo[];
  isComparisonActive: boolean;
  testId: string;
}

export function TopBottomCategories({ categories, isComparisonActive, testId }: TopBottomCategoriesProps) {
  const { getMeasuresByMetrics } = useModelService();

  const [pageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const categoryNavigate = useCategoryNavigate();

  const [ordGmvVal, ordQty] = getMeasuresByMetrics(['ordGmvVal', 'ordQty'], 'OD');
  if (categories.length === 0) {
    return <EmptyState />;
  }
  return (
    <TileContent className="flex flex-col justify-between items-center" data-testid={testId}>
      <TopList.ListContainer>
        {categories.slice((currentPage - 1) * pageSize, currentPage * pageSize).map(category => (
          <TopList.ListRow key={category.name} onClick={() => categoryNavigate(category.code)}>
            {/* Category Column */}
            <TopList.NameCell
              name={category.name}
              icon={findIconForCategory(category.code, 24)}
              color={category.color}
            />
            {/* GMV Column */}
            <TopList.MetricCell
              measure={ordGmvVal}
              value={ordGmvVal.getValue(category.entry.values)}
              comparisonValue={ordGmvVal.getValue(category.entry.compareValues)}
              unit={ordGmvVal.metric.unit}
              comparisonActive={isComparisonActive}
              size="lg"
            />
            {/* Quantity Column */}
            <TopList.MetricCell
              measure={ordQty}
              value={ordQty.getValue(category.entry.values)}
              comparisonValue={ordQty.getValue(category.entry.compareValues)}
              unit={ordQty.metric.unit}
              comparisonActive={isComparisonActive}
            />
          </TopList.ListRow>
        ))}
      </TopList.ListContainer>
      {Math.ceil(categories.length / pageSize) > 1 && (
        <Pagination
          className="mt-4"
          size="small"
          count={Math.ceil(categories.length / pageSize)}
          page={currentPage}
          onChange={(_event, page) => setCurrentPage(page)}
        />
      )}
    </TileContent>
  );
}
